import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-mfa-setup',
    templateUrl: './mfa-setup.component.html',
    styleUrls: ['./mfa-setup.component.css']
})
export class MfaSetupComponent implements OnInit, AfterViewInit {
    @ViewChild('codeInput') codeInput: ElementRef;
    // SafeUrl: the backend returns a server-generated data:image/svg+xml QR.
    // Angular sanitizes SVG data URIs out of [src]; this value is trusted because
    // it is built entirely server-side from the user's own secret (no user input),
    // and an SVG loaded via <img src> cannot execute scripts.
    qr: SafeUrl | string = '';
    code = '';
    message = '';
    submitting = false;

    constructor(private authservice: AuthService, private router: Router, private sanitizer: DomSanitizer) {}

    ngOnInit() {
        if (!this.authservice.pendingMfaToken) {
            this.router.navigate(['/login']);
            return;
        }
        this.authservice.mfaSetup().subscribe((res: any) => {
            if (res && res.qr) { this.qr = this.sanitizer.bypassSecurityTrustUrl(res.qr); }
        }, () => {
            this.message = 'Failed to load the QR code. Please go back and try logging in again.';
        });
    }

    ngAfterViewInit() {
        // Focus the code field so the user can type immediately without clicking.
        if (this.codeInput) {
            this.codeInput.nativeElement.focus();
        }
    }

    confirm() {
        if (!this.code) { return; }
        this.submitting = true;
        this.authservice.verifyMfa(this.code).subscribe((res: any) => {
            this.submitting = false;
            if (res && res.status) {
                this.authservice.completeLogin(res);
                this.router.navigate(['/news']);
            } else {
                this.message = (res && res.message) || 'Invalid code.';
            }
        }, () => {
            this.submitting = false;
            this.message = 'Invalid authentication code.';
        });
    }
}
